import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiSendMailMessage',
  standalone: false,
})
export class MultiSendMailMessagePipe implements PipeTransform {

  transform(values: Array<{lang_code: string, send_mail_message: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let send_mail_message: string = '';
    if (!!values) {
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      // const language = languages[0];
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            send_mail_message = value.send_mail_message;
            break;
          }
        }
      }
    }
    return send_mail_message;
  }

}
